import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { dbProxy, setAuthTokenGetter } from './db-proxy';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Clear any existing sessions from localStorage
if (typeof window !== 'undefined') {
  localStorage.removeItem('supabase.auth.token');
}

const supabaseClient = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: {
      getItem: (key) => {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
      },
      setItem: (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
      },
      removeItem: (key) => {
        localStorage.removeItem(key);
      }
    }
  }
});

// Wire up the auth token getter so db-proxy can use the current session
setAuthTokenGetter(async () => {
  const { data: { session } } = await supabaseClient.auth.getSession();
  return session?.access_token || supabaseAnonKey;
});

export const supabase = {
  auth: supabaseClient.auth,
  storage: supabaseClient.storage,
  channel: supabaseClient.channel.bind(supabaseClient),
  removeChannel: supabaseClient.removeChannel.bind(supabaseClient),
  from: dbProxy.from.bind(dbProxy),
  rpc: dbProxy.rpc.bind(dbProxy),
};